import { useTranslation } from 'react-i18next'

import { PageHeader } from 'components/Header'
import { GenerateReportSection } from 'features/yieldbirdWrapperAgent/sections/GenerateReportSection'
import { ReportsSection } from 'features/yieldbirdWrapperAgent/sections/ReportsSection'

export const YieldbirdWrapperAgentPage = (): React.JSX.Element => {
  const { t } = useTranslation('features/yieldbirdWrapperAgent')

  return (
    <>
      <PageHeader
        description={{ text: t('description') }}
        title={t('title')}
      />

      <GenerateReportSection />

      <ReportsSection />
    </>
  )
}
